import {State} from '@gongxigames/framework/slotV2/fsm/State';
import {parallel, sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {InstallSingletonsAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InstallSingletonesAct';
import {InitServicesAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitServicesAct';
import {InitInitialModulesAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitInitialModulesAct';
import {InitLogicAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitLogicAct';
import {LoadGameTextsAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadGameTextsAct';
import {LoadResourcesWithBeforePriorityAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadResourcesWithBeforePriorityAct';
import {LoadMetaDataForResourcesAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadMetaDataForResourcesAct';
import {LoadResourcesWithDefaultPriorityAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadResourcesWithDefaultPriorityAct';
import {LoadDeviceStyleAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadDeviceStyleAct';
import {LoadResourcesWithAfterPriorityAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/LoadResourcesWithAfterPriorityAct';
import {CheckDeviceIsSupportedAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/CheckDeviceIsSupportedAct';
import {PlayIntroAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/PlayIntroAct';
import {CheckHardwareAccelerationAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/CheckHardwareAccelerationAct';
import {StartGameAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/StartGameAct';
import {SystemInitializedAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/SystemInitializedAct';
import {InitSlotEventAdapterAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitSlotEventAdapterAct';
import {GameInitializedAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/GameInitializedAct';
import {InitDefaultModulesAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitDefaultModulesAct';
import {AddDeviceRelatedClassesAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/AddDeviceRelatedClassesAct';
import {InitializeLanguageServiceAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/InitializeLanguageServiceAct';
import {RefreshBalanceAct} from '@gongxigames/framework/slotV2/ui/acts/RefreshBalanceAct';
import {PlayOddsUpfrontAct} from '@gongxigames/framework/slotV2/modules/initialization/acts/PlayOddsUpfrontAct';
import {ReelsInitAct} from '@gongxigames/framework/slotV2/modules/reelsV2/acts/regular/ReelsInitAct';

export class InitState extends State {
    public static readonly ID = 'InitState';

    public setAct(): void {
        this.act = sequence([
            InstallSingletonsAct,
            InitServicesAct,
            AddDeviceRelatedClassesAct,
            InitializeLanguageServiceAct,
            InitInitialModulesAct,
            SystemInitializedAct,
            InitSlotEventAdapterAct,
            InitLogicAct,
            LoadGameTextsAct,
            LoadMetaDataForResourcesAct,
            LoadResourcesWithBeforePriorityAct,
            parallel([
                sequence([
                    CheckDeviceIsSupportedAct,
                    PlayIntroAct,
                    CheckHardwareAccelerationAct
                ]),
                sequence([
                    parallel([
                        LoadResourcesWithDefaultPriorityAct,
                        LoadDeviceStyleAct
                    ]),
                    InitDefaultModulesAct,
                    GameInitializedAct,
                    PlayOddsUpfrontAct,
                    RefreshBalanceAct,
                    LoadResourcesWithAfterPriorityAct
                ])
            ]),
            StartGameAct,
            ReelsInitAct
        ]);
    }
}